export const reCaptchConfig = {
    loadingTimeout: 30000, // 30 seconds
    showRecaptcha: true,
    siteKey: '6LdCMLcpAAAAAMWZcaIwSDFqVGo3p4aNq_-e5qrb',
}